module.exports = __webpack_public_path__ + "img/400(1).eea8210c.svg";